import { StyleSheet } from '@react-pdf/renderer';
import { theme } from '@/utils/theme';
import './fonts';

export const styles = {
  page: StyleSheet.create({
    wrapper: {
      fontFamily: 'Inter',
      fontWeight: 300,
      color: theme.palette['grey-9'].main,
      backgroundColor: '#FFFFFF',
      paddingVertical: 25,
      paddingHorizontal: 50,
    },
  }),
  header: StyleSheet.create({
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: 14,
    },
    logo: {
      width: '30%',
      height: 'auto',
    },
    title: {
      fontSize: 18,
    },
    titleLong: {
      fontSize: 16,
    },
    subtitle: {
      fontSize: 10,
      fontStyle: 'italic',
      fontWeight: 200,
      maxWidth: 250,
      textAlign: 'center',
    },
  }),
  section: StyleSheet.create({
    wrapper: {
      marginBottom: 20,
      flexGrow: 0,
    },
    title: {
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette['grey-8'].main,
      marginBottom: 8,
    },
  }),
  field: StyleSheet.create({
    wrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 8,
      paddingHorizontal: 12,
      paddingVertical: 8,
      marginBottom: 6,
      backgroundColor: theme.palette['grey-2'].main,
      borderRadius: 6,
    },
    longWrapper: {
      flexDirection: 'column',
    },
    label: {
      fontSize: 10,
      fontWeight: 600,
      color: theme.palette['grey-8'].main,
    },
    value: {
      fontSize: 10,
      fontWeight: 300,
      maxWidth: 300,
    },
    longValue: {
      maxWidth: '100%',
    },
  }),
  footer: StyleSheet.create({
    wrapper: {
      flexGrow: 1,
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    },
    qrCode: {
      flexGrow: 0,
      flexShrink: 0,
      width: 'auto',
      maxHeight: 150,
    },
  }),
};
